import {
  CloseButton,
  ErrorBoundary,
  JupiterTheme,
} from '@jupiterone/jupiter-web-toolkit';
import { Dialog, Grid, Slide } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { AccountModalPage } from 'navbar/src/jupiterAccountSettings/types';
import LeftNav from './components/LeftNav';
import RightNav from './components/RightNav';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    accessDetails: {
      paddingTop: 20,
      paddingBottom: 20,
    },
    accessDetailsPaper: {
      boxShadow: 'none',
      height: '100%',
      background: 'none',
      padding: 0,
      overflowX: 'hidden',
    },
    backdrop: {
      background: `url(https://raw.githubusercontent.com/JupiterOne/docs/main/assets/brand/starry-night-opaque.png) center center`,
      backgroundSize: 'cover',
    },
    grid: {
      background: 'none',
      height: '100%',
    },
    subGridItem: {
      height: '100%',
      width: '100%',
    },
    modalContainer: {
      height: '100%',
      boxShadow: `0px 3px 5px -2px rgba(0, 6, 42, .2)`,
    },
    closeGroupPanel: {
      position: 'sticky',
      top: 0,
      '&:last-child': {
        background: 'rgba(0,0,0, .5)',
        color: theme.palette.grey[100],
        float: 'right',
        marginRight: 20,
        '&:hover': {
          background: theme.palette.primary.dark,
          color: theme.palette.primary.contrastText,
        },
      },
    },
  })
);

interface IProps {
  onCloseModal: () => void;
  open: boolean;
  activePage?: AccountModalPage;
  setActivePage: (activePage: AccountModalPage) => void;
}

const TRANSITION_DELAY = 250;

const AccountSettingsModal = ({
  open,
  onCloseModal,
  activePage = 'profile',
  setActivePage,
}: IProps) => {
  const classes = useStyles();

  const changePage = (activePage: AccountModalPage) =>
    setActivePage(activePage);

  const closeEditAccountModal = () => {
    setTimeout(() => {
      onCloseModal();
    }, TRANSITION_DELAY);
  };

  const modalClasses = {
    paper: classes.accessDetailsPaper,
    modal: (classes as any).modalBackdrop,
  };
  const slideStyle: any = {
    transitionDelay: TRANSITION_DELAY,
    overflow: 'hidden',
  };

  return (
    <Dialog
      fullScreen={true}
      className={classes.accessDetails}
      open={open}
      onClose={closeEditAccountModal}
      classes={modalClasses}
      BackdropProps={{
        classes: {
          root: classes.backdrop,
        },
      }}
      onEscapeKeyDown={closeEditAccountModal}
    >
      <Grid container={true} spacing={1} className={classes.grid}>
        <Grid
          item={true}
          sm={1}
          lg={2}
          className={(classes as any).gridItemNav}
        />
        <Slide in={true} direction="up" timeout={250} style={slideStyle}>
          <Grid className={classes.subGridItem} item={true} sm={10} lg={8}>
            <Grid
              container={true}
              direction="row"
              justify="center"
              alignItems="stretch"
              className={classes.modalContainer}
            >
              <LeftNav onPageChange={changePage} activePage={activePage} />
              <RightNav activePage={activePage} />
            </Grid>
          </Grid>
        </Slide>
        <Grid item={true} sm={1} lg={2}>
          <CloseButton
            onClose={closeEditAccountModal}
            className={classes.closeGroupPanel}
          />
        </Grid>
      </Grid>
    </Dialog>
  );
};

const WrappedAccountSettingsModal = (props: IProps) => (
  <ErrorBoundary>
    {props.open && <AccountSettingsModal {...props} />}
  </ErrorBoundary>
);

export default WrappedAccountSettingsModal;
